import { render, staticRenderFns } from "./ChangeShopPricesProduct.vue?vue&type=template&id=372a638b"
import script from "./ChangeShopPricesProduct.vue?vue&type=script&lang=js"
export * from "./ChangeShopPricesProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports